import type { Dispatch } from 'react';
import { SET_LOADING } from 'src/contexts/types';
import { ApiV2 } from 'src/api/apiv2';
import { UPDATE_WARBOX_CONVERSATION } from '../constants/actions';
import { handleError } from 'src/contexts/utils/handleError';
import type { TWarboxConversationActionTypes } from '../types';
import type { TAPIOptions } from 'src/constants/apis/types';
import { HEADERS } from 'src/constants/headers';

export const updateConversation = async (
    dispatch: Dispatch<TWarboxConversationActionTypes>,
    body: Record<string, unknown> = {},
    conversationId: string,
    options: TAPIOptions = {
        isReadPermissionNecessary: false,
    }
): Promise<void> => {
    dispatch({ type: SET_LOADING });
    try {
        const config = HEADERS({
            isReadPermissionNecessary:
                options.isReadPermissionNecessary ?? false,
        });
        const res = await ApiV2.put(`/conversations/${conversationId}/update`, body, config);
        dispatch({ type: UPDATE_WARBOX_CONVERSATION, payload: res.data.data });
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
